import { Injectable } from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';

@Injectable({
    providedIn: 'root'
})
export class AlertService {
    constructor(private alertService: TuiAlertService) {}
    autoClose = 5000;

    showNegativeAlert(message: string, autoClose = this.autoClose): void {
        this.alertService
            .open('', {
                label: message,
                appearance: 'negative',
                autoClose
            })
            .subscribe();
    }

    showPositiveAlert(message: string, autoClose = this.autoClose): void {
        this.alertService
            .open('', {
                label: message,
                appearance: 'positive',
                autoClose
            })
            .subscribe();
    }

    showWarningAlert(message: string, autoClose = this.autoClose): void {
        this.alertService
            .open('', {
                label: message,
                appearance: 'warning',
                autoClose
            })
            .subscribe();
    }
}
